import { ModalWrapper } from 'src/components'
import { UpdateForm } from './update-form.component'
import { IQuantityTypeCategoryBaseWithId } from 'src/types'

import { useStyles } from '../styles'

interface IProps {
  open: boolean
  handleClose: () => void
  initialValues: IQuantityTypeCategoryBaseWithId
}

export const UpdateCategory = ({ open, handleClose, initialValues }: IProps) => {
  const classes = useStyles()

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <UpdateForm initialValues={initialValues} handleClose={handleClose} />
    </ModalWrapper>
  )
}
